module.exports = __webpack_public_path__ + "static/media/Zack Jarman Headshot_1728396662300.c6d1fe04.jpeg";